<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="slider_img" />
      </el-carousel-item>
    </el-carousel>
    <div class="solve head-label">
      <div style="text-align: center" class="font_size_24">一站式解决方案</div>
    </div>
    <!-- 盒子 -->
    <div class="border_parent">
      <el-row :gutter="10">
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[1].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[1].title }}</div>
            <div class="border_content_one">{{ images[1].content[0] }}</div>
            <div class="border_content_two">{{ images[1].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[2].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[2].title }}</div>
            <div class="border_content_one">{{ images[2].content[0] }}</div>
            <div class="border_content_two">{{ images[2].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[3].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[3].title }}</div>
            <div class="border_content_one">{{ images[3].content[0] }}</div>
            <div class="border_content_two">{{ images[3].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border" style="margin-right: 0">
            <div class="border_img_parent">
              <img :src="images[4].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[4].title }}</div>
            <div class="border_content_one">{{ images[4].content[0] }}</div>
            <div class="border_content_two">{{ images[4].content[1] }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 手机端商品展示 -->
    <div id="产品微观" class="head-label">
      <div style="text-align: center" class="font_size_24">产品微观介绍</div>
    </div>
    <div class="product_mobile">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_mobile_content">
            <div class="product_mobile_title font_size_30">
              {{ products[0].title }}
            </div>
            <div class="product_font_style product_mobile_content_one">
              {{ products[0].content[0] }}
            </div>
            <div class="product_font_style product_mobile_content_two">
              {{ products[0].content[1] }}
            </div>
            <div class="product_font_style product_mobile_content_two">
              {{ products[0].content[2] }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img :src="products[0].img[0]" class="product_mobile_img" />
          <img :src="products[0].img[1]" class="product_mobile_img" />
        </el-col>
      </el-row>
    </div>
    <!-- 后台管理 -->
    <div class="product_pc">
      <el-row>
        <el-col :xs="24" :sm="12">
          <div class="product_pc_one">
            <div class="product_mobile_title font_size_30">
              {{ manages[0].title }}
            </div>
            <div style="margin-top: 20px" class="product_font_style">
              {{ manages[0].content[0] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[1] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[2] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[3] }}
            </div>
            <div style="margin-top: 10px" class="product_font_style">
              {{ manages[0].content[4] }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <img :src="manages[0].img[0]" class="product_pc_img" />
        </el-col>
      </el-row>
    </div>
    <!-- 产品特点-->
    <div id="产品特点" class="product_spec_title head-label">
      <div style="text-align: center" class="font_size_24">产品特点</div>
    </div>
    <div class="product_spec_parent">
      <div class="border_one border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[0].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[0].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[0].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[0].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <div class="border_spec_img"></div>
        <!-- <img  :src="computeArrowImg" class="border_spec_img" /> -->
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[1].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[1].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[1].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[1].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <!-- <img :src="computeArrowImg" class="border_spec_img" /> -->
        <div class="border_spec_img"></div>
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[2].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[2].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[2].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[2].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <!-- <img :src="computeArrowImg" class="border_spec_img" /> -->
        <div class="border_spec_img"></div>
      </div>
      <div class="border_spec" style="margin-right: 0">
        <div class="border_spec_inner_one">
          <img :src="spec.product[3].img" style="width: 50px; height: 50px" />
          <div style="margin-left: 5px; font-weight: bold" class="font_size_24">
            {{ spec.product[3].title }}
          </div>
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="border_spec_content_one">
            {{ spec.product[3].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[3].contents[1] }}
          </div>
        </div>
      </div>
    </div>
    <!-- 微端应用-->
    <div id="微端应用" class="cooperation head-label">
      <div style="text-align: center" class="font_size_24">微端应用</div>
    </div>
    <div class="cooperation_parent">
      <div style="margin: 0 50px; text-align: center">
        <img
          style="height: 220px; width: 220px"
          src="../../static/other/qrcode_for_gh_06bd09b5becf_344.jpg"
        />
        <div>微信公众号</div>
      </div>
      <div style="margin: 0 50px; text-align: center">
        <img
          style="height: 220px; width: 220px; border-radius: 50%"
          src="../../static/other/gh_8728e2f6d350_344.jpg"
        />
        <div>微信小程序</div>
      </div>
    </div>
    <!-- 关于我们-->
    <div id="关于我们" class="about_me head-label">
      <div style="text-align: center" class="font_size_24">关于我们</div>
    </div>
    <div style="width: 90%; background-color: #f2f6fc; margin: 10px auto">
      <div style="display: flex; flex-direction: column; width: 100%">
        <p class="about_me_p">{{ company[0] }}</p>
        <p class="about_me_p">{{ company[1] }}</p>
        <p class="about_me_p">{{ company[2] }}</p>
        <p class="about_me_p">{{ company[3] }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      sliders: [],
      images: [
        {
          img: require("../../static/other/用户管理.png"),
          title: "用户管理",
          content: ["用户消费分析", "用户标签设定"],
        },
        {
          img: require("../../static/other/店铺管理.png"),
          title: "精品商品",
          content: ["平台自营产品", "优先保证质量"],
        },
        {
          img: require("../../static/other/数据分析.png"),
          title: "调查问卷",
          content: ["用户需求直观整理", "尽最大努力满足用户需求"],
        },
        {
          img: require("../../static/other/用户构建.png"),
          title: "贴心服务",
          content: ["所有产品按时送货上门", "用户粘连度提升"],
        },
        {
          img: require("../../static/other/品牌渠道.png"),
          title: "品牌渠道",
          content: ["打造店铺自主品牌", "品牌多样化管理"],
        },
      ],
      products: [
        {
          img: [
            require("../../static/other/手机端商品.png"),
            require("../../static/other/手机端商品SKU.png"),
          ],
          title: "包裹“免费”“按时”的送货上门",
          content: [
            "专人配送 优质服务，完美解决目前“最后一公里配送”问题",
            "想啥时候配送就啥时候配送！",
            "线上预约，直接上门，避免电话骚扰，降低沟通成本",
          ],
        },
      ],
      manages: [
        {
          img: [require("../../static/other/图片1.png")],
          title: "平台自营精选常购生活用品",
          content: [
            "平台自营，专注产品质量，货必对版",
            "厂商直达 省去中间商",
            "今天下单，次日达到",
            "免费送货上门，自主选择收货时间，省时省力",
            "质量问题，全额退款",
          ],
        },
      ],
      spec: {
        img: require("../../static/other/arrow.png"),
        product: [
          {
            img: require("../../static/other/手指.png"),
            title: "手指动一动",
            contents: ["免费送货上门", "让您足不出户快递到家"],
          },
          {
            img: require("../../static/other/店铺管理.png"),
            title: "自营商品",
            contents: ["精选商品", " 厂商直达省去中间商"],
          },
          {
            img: require("../../static/other/数据分析.png"),
            title: "调查问卷",
            contents: ["用户需求直观整理", "贴合用户打造出大家的平台"],
          },
          {
            img: require("../../static/other/助力零售.png"),
            title: "助力推广",
            contents: ["提供广告和活动模块", "帮助线下业态提升营销"],
          },
        ],
      },
      company: [
        "联系人：官方客服",
        "微信号：xiaoxiangio",
        "邮箱：xiaoxiangio@163.com",
        "地址：江西省吉安市吉州区古南大道12号。",
      ],
      carousel_height: "550px",
    };
  },
  methods: {},
  mounted() {
    this.sliders = [
      {
        img: "https://xxio.1001ballet.com/xiaochengxu/banner/home_banner1.jpg",
      },
      {
        img: "https://xxio.1001ballet.com/xiaochengxu/banner/f6f0b00f02a7411b52fafb11cce5889.jpg",
      },

      {
        img: "https://xxio.1001ballet.com/xiaochengxu/banner/home_banner2.jpg",
      },
      {
        img: "https://xxio.1001ballet.com/xiaochengxu/banner/20220103215255.png",
      },
      {
        img: require("../../static/slider/a1.jpg"),
      },
      {
        img: require("../../static/slider/a2.jpg"),
      },
      {
        img: require("../../static/slider/a3.jpg"),
      },
      {
        img: require("../../static/slider/a4.jpg"),
      },
    ];
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("../../static/other/arrow.png");
      } else {
        return require("../../static/other/arrow_down.png");
      }
    },
  },
};
</script>

<style scoped>
.border_parent {
  width: 90%;
  margin: auto;
}

.slider_img {
  height: 550px;
  width: 100%;
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 50%;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #f2f6fc;
  align-items: center;
}

.product_spec_title {
  margin-top: 30px;
  margin-bottom: 10px;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  height: 70px;
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: #f2f6fc;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: center;
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .slider_img {
    height: 250px;
    width: 100%;
  }

  .border_parent {
    display: flex;
    width: 90%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    height: auto;
    background: #f2f6fc;
  }

  .product_mobile_content {
    width: 100%;
    margin-top: 15px;
  }

  .product_mobile_content_one {
    margin-top: 5px;
  }

  .product_mobile_content_two {
    margin-top: 5px;
  }

  .product_mobile_img_div {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .product_mobile_img {
    float: left;
  }

  .product_mobile_title {
    font-weight: bold;
  }

  .product_pc_one {
    width: 100%;
    margin-top: 15px;
  }

  .font_size_30 {
    font-size: 1.25em;
  }

  .product_font_style {
    font-size: 1em;
  }

  .product_pc_img {
    height: 280px;
    width: 320px;
  }

  .product_pc_img_div {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }

  .product_pc {
    display: flex;
    width: 90%;
    height: auto;
    margin: 20px auto;
    background: #f2f6fc;
    flex-direction: column;
  }

  .head-label {
    display: flex;
    margin-top: 10px;
  }

  .product_spec_parent {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: auto;
    flex-direction: column;
  }

  .border_spec {
    float: left;
    height: auto;
    margin: 8px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: bold;
  }

  .border_content_one {
    margin-top: 5px;
    font-size: 1.125em;
  }

  .border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 8px;
  }

  .img_border {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
    /*background-color: aqua;*/
    height: 70px;
  }

  .border_spec_content_one {
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
  }

  .border_spec_inner_last {
    /*background-color: bisque;*/
    margin-top: 5px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 8px;
  }

  .about_me {
    display: flex;
    margin-top: 10px;
    width: 100%;
  }
}

.border_spec_img {
  width: 75px;
  height: 55px;
  align-self: center;
}

.font_size_24 {
  font-size: 1.5em;
}
</style>